// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.CartPage.RecentlyView'
,	[
        'Utils',
		'Backbone.CollectionView',
        'Backbone',
        'RecentlyViewedItems.Collection',
        'C3.ShoppingExtensions.CartPage.RecentlyView.ItemCell',
        'Tracker',
       // 'SC.Configuration',
        'recently_viewed_cell.tpl',
        'recently_viewed_row.tpl',
        'recently_viewed_items.tpl'
    ]
, function (
    Utils,
	BackboneCollectionView,
    Backbone,
    RecentlyViewedItemsCollection,
    RecentlyViewedItemView,
    Tracker,
   // Configuration,
    recently_viewed_cell_tpl,
    recently_viewed_row_tpl,
    recently_viewed_items_tpl
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return BackboneCollectionView.extend({

		initialize: function (options) {

            this.application = options.application;
            var config = this.application.Configuration
            ,   siteSettings = config.siteSettings
            ,   sitetype = siteSettings.sitetype
            ,   recentlyViewedItems = config.recentlyViewedItems
            ,   numberOfItemsDisplayed = recentlyViewedItems.numberOfItemsDisplayed || 4


            this.container = options.container;

            this.numberOfItemsDisplayed = numberOfItemsDisplayed

            var is_sca_advance =
            sitetype === 'ADVANCED';

            var layout = this.application.getLayout();
            var collection =
                sitetype === 'ADVANCED'
                    ? RecentlyViewedItemsCollection.getInstance()
                    : new Backbone.Collection();
            var self = this;

            //console.log(collection)
            var collection_models = collection.models || '';
            //console.log(collection_models.length)
            BackboneCollectionView.prototype.initialize.call(this, {
                collection: collection,
                viewsPerRow: Infinity,
                cellTemplate: recently_viewed_cell_tpl,
                rowTemplate: recently_viewed_row_tpl,
                childView: RecentlyViewedItemView,
                template: recently_viewed_items_tpl,
                childViewOptions: {
                    origin: 'CartPage-RecentlyViewed',
                    hideArrows : collection_models.length <= 5 ? true : false,
                    application : this.application,
                    container : this.container
                }
            });

            //console.log(layout.currentView)
            //layout.once('afterAppendView', self.loadRecentlyViewedItem, self);
            if (is_sca_advance) {
            layout.once('afterAppendView', self.loadRecentlyViewedItem, self);
            layout.currentView &&
                layout.currentView.once('afterCompositeViewRender', self.loadRecentlyViewedItem, self);
            }
            /*if (is_sca_advance) {
                this.once('afterCompositeViewRender', this.loadRecentlyViewedItem, this);
            }*/
		},

		loadRecentlyViewedItem: function loadRecentlyViewedItem() {
            var self = this;

        RecentlyViewedItemsCollection.getInstance().turnOnTracking();

        var collection_models = this.collection.models || '';
        this.collection.promise &&
            this.collection.promise.done(function() {
                var application = self.application;
                var number_of_items_displayed = self.numberOfItemsDisplayed

                self.collection = self.collection.first(parseInt(number_of_items_displayed));
                self.render();

                var carousel = self.$el.find('[data-type="carousel-items-recently-viewed"]');

                 const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.application.Configuration;
                
                if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }

                //console.log(collection_models.length)

                bxSliderDefaults.controls = collection_models.length >= 6 ? true : false;

                if(collection_models.length >= 6)
                bxSliderDefaults.slideWidth = 250;
                else
                bxSliderDefaults.slideWidth = 260;    

                /*if(Utils.isPhoneDevice())
                    bxSliderDefaults.slideWidth = 210;*/
                //bxSliderDefaults.controls = true;
                bxSliderDefaults.hideControlOnEnd = true;
                bxSliderDefaults.maxSlides = 5;
                bxSliderDefaults.prevText = '<a data-click="left-click" data-action="cart-recentlyview-click" class="cart-recently-viewed carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
                bxSliderDefaults.nextText = '<a data-click="right-click" data-action="cart-recentlyview-click" class="cart-recently-viewed carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';         
                
                /*bxSliderDefaults.prevText = '<a class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';
                bxSliderDefaults.nextText = '<a class="carousel-items-next-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
                *///bxSliderDefaults.touchEnabled = false;
                //console.log(bxSliderDefaults.controls)
                bxSliderDefaults.infiniteLoop = false;
                Utils.initBxSlider(carousel, bxSliderDefaults);

                if(collection_models.length <= 5){
                    //$('.recently-viewed-items-row .bx-has-controls-direction').css('display','none');
                    //$(".recently-viewed-cell-item").attr('style', 'padding-left:0px !important');
                    //$(".recently-viewed-items-row .bx-viewport").attr('style', 'margin-left:0px !important');
                    $(".recently-viewed-cell-item").css('padding-left','0px')
                    $(".recently-viewed-items-row .bx-viewport").css('margin-left','0px')
                }
            });
    }

	});
});
